// Lib
import { classicFormatMaxTwoDigits } from '@/utils/hooks/format/useFormatNumber';

import { SIZE_50 } from '@/lib/gridElements/size';

// Components
import { LineChart } from '@/components/composite/Charts/LineChart';

export const followerGrowthHistoryConfig = {
    title: 'chart.twitter.follower_growth',
    margin: { left: -20, right: 10 },
    name: {
        date: 'date',
        value: 'chart.twitter.follower_growth_name',
        avg: 'chart.twitter.follower_growth'
    },
    id: 'followers_history',
    color: {
        value: 'blue',
        avg: 'gray'
    },
    valueFormat: classicFormatMaxTwoDigits,
    tooltip: 'chart.twitter.tooltip_follower_growth',
    size: SIZE_50,
    type: 'chart',
    element: LineChart
};
